/**
 * @packageDocumentation
 * @module HackerAPI
 */
import Axios from "axios";
import Error from "../error/error";
import * as Utils from "../utils/utils";
import Auth from "../auth/auth";
/**
 * The base host url path for making all request
 * @constant
 * @type { string }
 */
//const BASE_URL = 'https://hackerapi.com';
var BASE_URL = "https://hackerapi.com";
/**
 * @typedef { Object } HackerAPIFetchOptions
 * @property { string } path - The path added after the host part of the url. Must begin with "/".
 * @property { string } token - The authentication token for the user.
 * @property { string } method - The type of request to send. Can be "GET", "PUT", "POST" or "DELETE".
 * @property { object } params - Any parameters to sent at the end of the url
 * @property { object } body - Anything to sent in the body of the request
 */
/**
 * A wrapper for making HTTP requests to the hacker API using promises
 * @param options
 */
var HackerAPIFetch = function (_a) {
    var path = _a.path, _b = _a.token, token = _b === void 0 ? Auth.token : _b, _c = _a.method, method = _c === void 0 ? "GET" : _c, _d = _a.params, params = _d === void 0 ? {} : _d, _e = _a.body, body = _e === void 0 ? {} : _e, _f = _a.responseType, responseType = _f === void 0 ? "json" : _f, _g = _a.fullResponse, fullResponse = _g === void 0 ? false : _g;
    token = Utils.parseToken(token);
    if (token) {
        params.token = token;
    }
    return Axios({
        method: method,
        url: BASE_URL + path,
        params: params,
        data: body,
        responseType: responseType
    })
        .then(function (res) {
        return fullResponse ? res : res.data;
    })
        .catch(function (err) {
        throw new Error(err);
    });
};
/**
 * @module HackerAPI
 */
export default HackerAPIFetch;
//# sourceMappingURL=hackerapi-fetch.js.map